/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc. For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

// Primeng Modules
import { ToastModule } from 'primeng/toast';

// Our custom Angular Components
import { OfflineNotificationComponent } from './offline-notification/offline-notification.component';
import { BulbActivityServiceProvider } from '../angularjs.providers';

/**
 * Bulb Offline Notification module.
 */
@NgModule({
  declarations: [
    OfflineNotificationComponent,
  ],
  imports: [
    CommonModule,
    ToastModule,
    TranslocoModule,
  ],
  exports: [
    OfflineNotificationComponent,
  ],
  providers: [
    BulbActivityServiceProvider,
    MessageService,
  ],
})
export class OfflineModule { }
